module.exports = __webpack_public_path__ + "assets/img/c6.65bd3058.png";